export default __webpack_public_path__ + "static/media/eth-bg.52344ebd.png";